module.exports = __webpack_public_path__ + "img/MENU_logo_login.39e37fe0.png";